import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

import MeetingAPI from '../../api/MeetingAPI';
import ApiUiController from '../../controller/ApiUiController';
import ActionController from '../../controller/ActionController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import Const from '../../util/Constants';
import DB from '../../util/LocalDB';
import PropertyAPI from '../../api/PropertyAPI';

class InnerMeetingList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).meeting;
    this.state = { inApiCall: true, meetings: [], propertyNames: {} };

    const user = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);
    this.User = Const.Opt + user + Const.Opt;

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermInnerListRestrict);

    this.fields = Object.keys(this.model.fields).map(key => this.model.fields[key]).filter(field => field.visible && field.field_key !== 'status' && field.field_key !== 'next_meet' && field.field_key !== 'contacts')
      .sort((l, r) => l.field_order - r.field_order);

    this.actions = DB.getActions(Const.Meeting);
  }

  componentDidMount() { this.loadMeetings(this.props.id); }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, meetings: [], propertyNames: {} });
      this.loadMeetings(props.id);
    }
  }

  loadMeetings = meetingId => MeetingAPI.getInnerList(this.props.type, meetingId, this.onReceived, this.onFail, this.Restrict, this.User);
  
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('meeting', res.count);
    }
    this.setState({ inApiCall: false, meetings: res.data }, () => {
      // Load property names for all meetings
      this.loadPropertyNames();
    });
  };
  
  loadPropertyNames = async () => {
    const propertyNames = {};
    for (const meeting of this.state.meetings) {
      if (meeting.property && meeting.property !== '~~') {
        let propertyId = meeting.property;
        // Handle both number and string with tildes
        if (typeof propertyId === 'string' && propertyId.includes('~')) {
          propertyId = propertyId.substring(1, propertyId.length - 1);
        }
        try {
          const name = await this.getPropertyName(propertyId);
          propertyNames[meeting.id] = name;
        } catch (err) {
          console.error('Error fetching property name:', err);
          propertyNames[meeting.id] = propertyId;
        }
      }
    }
    this.setState({ propertyNames });
  };
  
  getPropertyName = (id) => {
    return new Promise((resolve) => {
      PropertyAPI.get(parseInt(id), (res) => {
        resolve(res && res.name ? res.name : id);
      }, (err) => {
        console.error(err);
        resolve(id);
      });
    });
  };
  
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      MeetingAPI.delete(this.state.meetings[indx].id, this.onDeleteSuccess, this.onFail);
    });
  
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Meeting deleted successfully', 'success');
    this.props.reload();
  };

  showList = () => this.state.meetings.map((meeting, _i) => {
    return (
      <tr key={`meeting_${_i + 1}`}>
        {this.fields.map((field, _j) => {
          // Special handling for property field
          if (field.field_key === 'property') {
            const propertyName = this.state.propertyNames[meeting.id];
            return <td key={`i_${_i}_${_j}`}>{propertyName || '...'}</td>;
          }
          return <td key={`i_${_i}_${_j}`}>{Display.FieldValue(meeting, field.field_key, this.model.fields)}</td>;
        })}
        <td>
          {ActionController.checkAction(Const.PermUpdate, this.Update, this.actions, meeting) ?
            <span onClick={evnt => this.props.edit(meeting, LeadConst.Meeting)} className="buttons update buttons-sm">
              <FaPencilAlt /> Edit
            </span>
            : null
          }
          {ActionController.checkAction(Const.PermDelete, this.Delete, this.actions, meeting)
            ? <span onClick={() => this.onDelete(_i)} className="buttons delete buttons-sm"><FaTrash /> Delete</span> : null}
        </td>
      </tr>
    );
  });

  render() {
    let uiMeetings = this.showList();
    if (this.state.meetings.length === 0) {
      uiMeetings = (
        <tr>
          <td colSpan={this.fields.length + 1}>No Records Found</td>
        </tr>
      );
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>{this.model.model_name}s</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    {this.fields.map((field, i) => <th key={`h_${i}`}>{field.label_name}</th>)}
                    <th className="actionth">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {uiMeetings}
                </tbody>
              </Table>
            </div>  
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default InnerMeetingList;